import Styles from './JobCard.module.scss'
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

export function JobCard({ data, callback }) {

    const containerName = process.env.REACT_APP_AZURE_BLOB_CONTAINER_NAME_HIRING;
    return (
        data &&
        <div
            className={Styles.mainContainer}
            onClick={callback && callback}
        >
            <div className={Styles.orgIcon}>
                <img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}/${containerName}/logos/${data?.org_logo}`} alt='org icon' />
            </div>
            <span className={Styles.org} >
                <Typography 
                    sx={{
                        fontWeight: '600',
                    }}
                >
                    {data?.job_position}
                </Typography>

                <p className={Styles.orgTitle}>
                    {data?.org_name}
                </p>
            </span>
            <div className={Styles.detailsContainer}>
                {data.job_details && Object.entries(data.job_details).map(([key, value]) => (

                    <Chip
                        key={`${value}-${data?.job_position}`}
                        label={key === 'experience' ? `${value[0]} - ${value[1]} years` : value}
                        sx={{
                            borderRadius: '8px',
                            textOverflow: "ellipsis",
                            maxWidth: '15ch',
                            minWidth: "15ch",
                            // padding: '0.2em'

                        }}

                    />
                ))}
            </div>
            <div className={Styles.date}>
                <Chip label={data?.date_posting} variant='outlined' sx={{ borderColor: 'transparent', color: '#d0d0d0', fontSize: '1rem' }} />


            </div>
        </div>
    )
}